module.exports = __webpack_public_path__ + "media/images/amenities_icons/ac-7c733ea755c49c7e4f977a71066747be.svg";